import { useContext } from 'react';
import FormContext from 'context/ContactForm';
import styled from '@emotion/styled';
import { LuX } from 'react-icons/lu';

const InputContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
`;

const StyledInput = styled.input`
  all: unset;
  ${({ theme }) => theme.mixins.Body};
  color: ${({ theme }) => theme.colors.white};
  width: 100%;
  background: transparent;
  outline: none;
  padding: 1rem;
  border-top: 1px solid ${({ theme }) => theme.colors.gray};

  &:focus + label {
    display: none;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    &:hover + label {
      color: ${({ theme }) => theme.colors.gray};
    }
  }

  :not(input:-webkit-autofill)::-webkit-contacts-auto-fill-button {
    background-color: ${({ theme }) => theme.colors.gray};
    position: absolute;
    right: 0rem;
  }
`;

const StyledLabel = styled.label`
  all: unset;
  ${({ theme }) => theme.mixins.Body};
  color: ${({ theme }) => theme.colors.white};
  position: absolute;
  margin-left: 1rem;
  transition: color 0.3s ease;
`;

const ClearButton = styled.button`
  all: unset;
  position: absolute;
  right: 0;
  height: 100%;
  margin-right: 1rem;

  &:hover {
    color: ${({ theme }) => theme.colors.green};
    cursor: pointer;
  }

  svg {
    font-size: 1.8rem;
  }
`;

const FormInput = ({
  name,
  label,
  type,
  required,
  value: propValue,
  onChange: propOnChange,
  showClearButton = true,
}) => {
  const formContext = useContext(FormContext);

  const isUsingContext = formContext && !propValue && !propOnChange;

  const value = isUsingContext
    ? formContext.formData[name] || ''
    : propValue || '';

  const handleChange = (e) => {
    if (isUsingContext) {
      formContext.updateFormData(name, e.target.value);
    } else {
      propOnChange?.(e);
    }
  };

  const inputId = `input-${label.replace(/\s+/g, '-').toLowerCase()}`;

  const handleClear = () => {
    if (isUsingContext) {
      formContext.updateFormData(name, '');
    } else {
      propOnChange?.({ target: { value: '', name } });
    }
  };

  return (
    <InputContainer>
      <StyledInput
        id={inputId}
        name={name}
        type={type}
        value={value}
        required={required}
        onChange={handleChange}
        aria-labelledby={`${inputId}-label`}
        autoCapitalize="none"
        autoCorrect="off"
      />
      {!value && (
        <StyledLabel id={`${inputId}-label`} htmlFor={inputId}>
          {label}
        </StyledLabel>
      )}
      {showClearButton && value && (
        <ClearButton
          type="button"
          onClick={handleClear}
          aria-label={`Clear ${label}`}
        >
          <LuX />
        </ClearButton>
      )}
    </InputContainer>
  );
};

export default FormInput;
